
require('./learnMoreDialog.styles');
export function LearnMoreDialogController(
	$mdDialog, 
	context, 
	state
) {
	let vm = this;
	vm.context = context;
	vm.state = state;
	vm.cancel = function(){ $mdDialog.cancel(); };
}

LearnMoreDialogController.$inject =  [
	'$mdDialog',
	'context',
	'state'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/learnMoreDialog/learnMoreDialog.ts